import {Types} from 'mongoose';
import {
    AbsenceEarlyWarningMailSkipReason,
    AbsenceEarlyWarningMailStatus,
    AbsenceEarlyWarningTriggerMode,
} from '@/enums/workflow-manager/AbsenceEarlyWarning.enum';

/**
 * Optional structured origin of a to-do (shrd ToDoItemSource), set by services such as the early warning.
 * Readable together with the description. To-dos without it show their description as before.
 */
export enum ToDoItemSourceTypes {
    ABSENCE_EARLY_WARNING = 'absenceEarlyWarning',
}

export type AbsenceEarlyWarningToDoSource = {
    type: `${ToDoItemSourceTypes.ABSENCE_EARLY_WARNING}`;
    record?: Types.ObjectId | string;
    workflow?: Types.ObjectId | string;
    ruleName?: string;
    summary?: string;
    triggerMode?: AbsenceEarlyWarningTriggerMode;
    threshold?: number;
    window?: number;
    countExcused?: boolean;
    /** Latest evaluated lessons, newest first (0 anwesend, 1 entschuldigt, 2 unentschuldigt) */
    lessons?: Array<{ state: number; instance: Date | string }>;
    course?: {
        customId?: string; course?: Types.ObjectId | string; subject?: string; dayOfWeek?: number; startTime?: number; endTime?: number;
        institution?: Types.ObjectId | string; institutionName?: string; city?: string; state?: string;
    };
    mail?: {
        status?: AbsenceEarlyWarningMailStatus; reason?: AbsenceEarlyWarningMailSkipReason;
        recipientType?: 'parent' | 'student'; recipient?: string; recipientName?: string;
    };
    /** The description was edited by hand: show it in addition */
    descriptionEdited?: boolean;
};

export type ToDoItemSource = AbsenceEarlyWarningToDoSource;
